import React, { useState } from 'react';
import classnames from 'classnames';

import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';

//utils
import { DivideByKeyResultTypes } from '../../../utils';

// interfaaces
import { ContactTypes } from '../../../data/contacts';
import { getChatUserDetails } from '../../../redux/actions';
import { useRedux } from '../../../hooks';

interface ContactItemProps {
    contact: ContactTypes;
    onSelectChat: (personId: number, isChannel?: boolean) => Promise<void>;
    openEditModal: () => void;
    openDeleteModal: () => void;
}
const ContactItem = React.forwardRef(
    (
        {
            contact,
            onSelectChat,
            openEditModal,
            openDeleteModal
        }: ContactItemProps,
        ref: React.ForwardedRef<HTMLLIElement>
    ) => {
        const { dispatch } = useRedux();
        const [dropdownOpen, setDropdownOpen] = useState(false);

        const toggle = (e: any) => {
            e.stopPropagation();
            dispatch(getChatUserDetails(contact.personId!));
            setDropdownOpen(!dropdownOpen);
        };

        const displayName =
            contact.displayName || `${contact.firstName} ${contact.lastName}`;
        const shortName = `${contact.firstName.charAt(0)}${contact.lastName.charAt(
            0
        )}`;
        /* const colors = [
            'bg-primary',
            'bg-danger',
            'bg-info',
            'bg-warning',
            'bg-secondary',
            'bg-pink',
            'bg-purple'
        ]; */
        /* const [color] = useState(Math.floor(Math.random() * colors.length)); */

        const contactContent = (
            <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                    <div className="avatar-xs">
                        {contact.profileImage ? (
                            <img
                                src={contact.profileImage}
                                alt=""
                                className="img-fluid rounded-circle"
                            />
                        ) : (
                            <span
                                className={classnames(
                                    'avatar-title',
                                    'rounded-circle',
                                    'font-size-10',
                                    'text-uppercase',
                                    'bg-secondary'
                                )}
                            >
                                {shortName}
                            </span>
                        )}
                    </div>
                </div>
                <div className="flex-grow-1">
                    <h5 className="font-size-14 m-0">{displayName}</h5>
                </div>
                <div className="flex-shrink-0">
                    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle tag="a" className="text-mute">
                            <i className="bx bx-dots-vertical-rounded align-middle"></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem
                                className="d-flex align-items-center justify-content-between"
                                href="#"
                                onClick={openEditModal}
                            >
                                Edit{' '}
                                <i className="bx bx-pencil ms-2 text-muted"></i>
                            </DropdownItem>
                            {/* <DropdownItem
                                className="d-flex align-items-center justify-content-between"
                                href="#"
                            >
                                Block{' '}
                                <i className="bx bx-block ms-2 text-muted"></i>
                            </DropdownItem> */}
                            <DropdownItem
                                className="d-flex align-items-center justify-content-between"
                                href="#"
                                onClick={openDeleteModal}
                            >
                                Remove{' '}
                                <i className="bx bx-trash ms-2 text-muted"></i>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
        );

        return ref ? (
            <li ref={ref} onClick={() => onSelectChat(contact.personId!)}>
                {contactContent}
            </li>
        ) : (
            <li onClick={() => onSelectChat(contact.personId!)}>
                {contactContent}
            </li>
        );
    }
);
interface CharacterItemProps {
    letterContacts: DivideByKeyResultTypes;
    index: number;
    onSelectChat: (personId: number, isChannel?: boolean) => Promise<void>;
    openEditModal: () => void;
    openDeleteModal: () => void;
}
const CharacterItem = React.forwardRef(
    (
        {
            letterContacts,
            index,
            onSelectChat,
            openEditModal,
            openDeleteModal
        }: CharacterItemProps,
        ref: React.ForwardedRef<HTMLLIElement>
    ) => {
        return (
            <div className="mt-3">
                <div className={classnames({ 'mt-3': index !== 0 })}>
                    <div className="contact-list-title">
                        {letterContacts.letter}
                    </div>

                    <ul className="list-unstyled contact-list">
                        {(letterContacts.data || []).map(
                            (contact: any, key: number) => {
                                if (
                                    ref &&
                                    letterContacts.data.length === key + 1
                                ) {
                                    return (
                                        <ContactItem
                                            contact={contact}
                                            key={key}
                                            onSelectChat={onSelectChat}
                                            openEditModal={openEditModal}
                                            openDeleteModal={openDeleteModal}
                                            ref={ref}
                                        />
                                    );
                                } else {
                                    return (
                                        <ContactItem
                                            contact={contact}
                                            key={key}
                                            onSelectChat={onSelectChat}
                                            openEditModal={openEditModal}
                                            openDeleteModal={openDeleteModal}
                                        />
                                    );
                                }
                            }
                        )}
                    </ul>
                </div>
            </div>
        );
    }
);

export default CharacterItem;
